Wee.fn.make('quoteForm', {
	init: function() {
		var priv = this.$private;

		priv.store = Wee.fn.storage();

		priv.initEvents();
		priv.addData();
		priv.showItems();

		Wee.dropdown.init({
			placeholder: false,
			isSelected: true,
			rootModifier: '-quote',
			visibleItems: 5
		});
	},

	unload: function() {
		$.events.off(false, '.quoteForm');
	}
}, {
	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		$.events.on({
			'ref:quoteFormCheckbox': {
				click: function(e, el) {
					$(el).parent('.-checkbox').toggleActive();
				}
			},

			'ref:quoteForm': {
				submit: function(e, el) {
					$('.quote-form__submit').attr('disabled', true);

					Wee.fetch.request({
						url: $('input[name=action]', el).val(),
						method: 'post',
						type: 'form',
						json: true,
						data: $('ref:quoteForm').serialize(),
						success: function(data) {
							if (data.returnUrl) {
								$.history.go({
									path: data.returnUrl
								});

								sessionStorage.clear();
							}
						}
					});

					e.preventDefault();
				}
			}
		}, {
			namespace: 'quoteForm'
		});
	},

	/**
	 * Add data from session storage to quote form
	 *
	 * @private
	 */
	addData: function() {
		this.store = Wee.fn.storage();

		var data = this.store.get('items'),
			prettyData = [];

		for (var i = 0; i < data.length; i++) {
			for (var key in data[i]) {
				switch (key) {
					case 'productName':
						prettyData.push('Product Name: ' + data[i].productName);
						break;
					case 'productType':
						prettyData.push('Product Type: ' + data[i].productType);
						break;
					case 'productPrice':
						prettyData.push('Price: ' + data[i].productPrice);
						break;
					case 'productSalePrice':
						prettyData.push('Sale Price: ' + data[i].productSalePrice);
						break;
					case 'productImage':
						prettyData.push('Image: ' + data[i].productImage);
						break;
					case 'productMountingOptions':
						prettyData.push('Mount: ' + data[i].productMountingOptions);
						break;
					case 'productColorOptions':
						prettyData.push('Color: ' + data[i].productColorOptions);
						break;
					case 'productQuantity':
						prettyData.push('Quantity: ' + data[i].productQuantity + '\n');
						break;
				}
			}
		}

		$('#form-input-quoteCartData').val(prettyData.join('\n'));
	},

	/**
	 *	Render list of products in quote
	 *
	 * @private
	 */
	showItems: function() {
		this.app = Wee.app.make('quote-form', {
			target: 'ref:quoteFormTop',
			view: 'quote-form',
			model: this.createDataModel()
		});
	},

	/**
	 * Create data model for Wee app
	 *
	 * @private
	 */
	createDataModel: function() {
		var scope = this,
			items = scope.store.get('items');

		// Only if price and sale price are shown on entry page
		for (var i = 0; i < items.length; i += 1) {
			if (items[i].productSalePrice) {
				items[i].salePrice = true;
			} else {
				items[i].salePrice = false;
			}
		}

		return {
			items: items,
			quotePricing: $.get('showPricing', false)
		};
	}
});